import { useEffect } from "react";
import { usePage } from "@inertiajs/react";
import * as Sentry from "@sentry/react";
import type { SharedPageProps } from "~/layouts/types";
import { useProjectId } from "~/stores/projectStore";

/**
 * Sets Sentry user context and tags from shared page props and project store.
 * Subscribes to the project store (not props) for projectId because it may
 * be created mid-session via Langgraph state (e.g. brainstorm → project creation).
 */
export function useSentryIdentify() {
  const props = usePage().props as SharedPageProps;
  const projectId = useProjectId();

  useEffect(() => {
    if (props.current_user) {
      Sentry.setUser({
        id: String(props.current_user.id),
        email: props.current_user.email,
      });
      Sentry.setTag("role", props.current_user.admin ? "admin" : "user");
      Sentry.setTag("impersonating", String(!!props.impersonating));
      Sentry.setTag("account_id", props.account_id ? String(props.account_id) : undefined);
    } else {
      Sentry.setUser(null);
    }
  }, [props.current_user, props.impersonating, props.account_id]);

  useEffect(() => {
    if (projectId) {
      Sentry.setTag("project_id", String(projectId));
    } else {
      Sentry.setTag("project_id", undefined);
    }
  }, [projectId]);
}
